import { notification_color_keys, useNotifications } from "utils/hooks";
import { useCustomMutation } from "data/modules/api/hooks/useCustomMutation";
import useCustomQueryClient from "data/modules/api/hooks/useQueryClient";
import { SOMETHING_WENT_WRONG } from "constants/displayStrings";
import { UPDATE_CUSTOM_COLUMN } from "../constants/CustomColumns.api";
import { useEditCustomColumnModal } from "../../EditCustomColumnModal/utils/useEditCustomColumnModal";
import { getCustomColumnQueryKey } from "./customColumnQueryKeys";

export const useUpdateCustomColumn = ({ sectionName }) => {
  const queryClient = useCustomQueryClient();
  const { notify } = useNotifications();
  const { closeEditCustomColumnModal } = useEditCustomColumnModal();

  return useCustomMutation({
    url: UPDATE_CUSTOM_COLUMN,
    onSuccess: () => {
      notify("Column Updated Successfully!", notification_color_keys.success);
      queryClient.invalidateQueries({
        queryKey: getCustomColumnQueryKey({ section_name: sectionName }),
      });
      closeEditCustomColumnModal();
    },
    onError: (err) => {
      notify(
        err?.response?.data?.message || SOMETHING_WENT_WRONG,
        notification_color_keys.error
      );
    },
  });
};
